// extracted by mini-css-extract-plugin
module.exports = {"hide_modal":"ViewPalletLotModal_hide_modal__NMOoX","modal":"ViewPalletLotModal_modal__NHo9m"};